'use strict';

// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';

import { layer } from './plugins/layer/index.js';

import Lenis from 'lenis';

import LazyLoad from 'vanilla-lazyload';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

// import { Fancybox } from '@fancyapps/ui/dist/fancybox/index.js';
// import '@fancyapps/ui/dist/fancybox/fancybox.css';

// import * as THREE from 'three';

// import Masonry from 'masonry-layout';

import './iconfont/iconfont.js';

import { initMenu } from './modules/menu.js';
import { initEmblaCarousel } from './modules/embla-carousel.js';
// import { initGsap } from './modules/gsap.js';
import { initPage } from './modules/page.js';

import { checkAutoplaySupport, slideDown, slideUp, checkViewTransition } from './utiles/index.js';

import { SmartNavigation } from './modules/smartNavgation.js';

// Initialize Lenis
const lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', () => {
	// new SmartNavigation();

	// 测试用
	const domLoop = document.querySelectorAll('[data-loop]');
	if (domLoop) {
		domLoop.forEach((item) => {
			const len = item.getAttribute('data-loop');
			const sourceItem = item.innerHTML;
			for (let i = 0; i < len; i++) {
				item.innerHTML += sourceItem;
			}
		});
	}

	// Menu
	initMenu(lenis);

	// initGsap();
	initPage();

	initEmblaCarousel();

	// AOS.js
	AOS.init({
		duration: 800,
		offset: 40,
		once: true,
		startEvent: 'load',
		easing: 'cubic-bezier(0, 0.55, 0.45, 1)',
	});

	// 防抖处理 AOS.refresh
	let scrollTimer;
	lenis.on('scroll', ({ animatedScroll, direction }) => {
		clearTimeout(scrollTimer);
		scrollTimer = setTimeout(() => {
			AOS.refresh();
		}, 100); // 100ms 防抖延迟
	});

	// LazyLoad
	const myLazyLoad = new LazyLoad({
		threshold: 1000,
	});
});
